export const CAUSE_FETCH_PARENT_FIELD_NOT_FOUND = 'FETCH_PARENT_FIELD_NOT_FOUND';
export const CAUSE_FETCH_PARENT_FIELD_DETAILS_MISSING_DATA =
	'FETCH_PARENT_FIELD_DETAILS_MISSING_DATA';
export const CAUSE_FETCH_PARENT_FIELD_UNKNOWN_ERROR = 'FETCH_PARENT_FIELD_UNKNOWN_ERROR';
export const CAUSE_FETCH_PARENT_FIELD_DETAILS_REQUEST_FAILED =
	'FETCH_PARENT_FIELD_DETAILS_REQUEST_FAILED';
